import { useAppDispatch, useAppSelector } from 'app/hooks';
import {
    selectIsROneFeatureEnabled,
    selectIsSectionsModeEnabled,
    setSectionsModeEnabled,
} from 'store/featureFlag/featureFlagSlice';

export const useSectionsFeatureFlag = () => {
    const dispatch = useAppDispatch();
    const isFeatureEnabled = useAppSelector(selectIsROneFeatureEnabled);
    const isSectionsModeEnabled = useAppSelector(selectIsSectionsModeEnabled);

    const handleSectionsModeChange = (enabled: boolean) => {
        dispatch(setSectionsModeEnabled(enabled));
    };

    return {
        isFeatureEnabled,
        isSectionsModeEnabled,
        handleSectionsModeChange,
    };
};
